import {
  BOLT_STAR_ONBOARDING_DIALOG_DISMISSED_KEY,
  BOLT_STAR_PAGE_ONBOARDING_DIALOG_DISMISSED_KEY,
} from '@provider-portal/common/LocalStorageKeys';
import { getStorageItem, setStorageItem } from '@provider-portal/common/utils/storage';
import { OnboardingPopupVariant } from '@provider-portal/mp2-common/topPerformer';

const DISMISSED_KEYS: Record<OnboardingPopupVariant, string> = {
  [OnboardingPopupVariant.DEFAULT]: BOLT_STAR_ONBOARDING_DIALOG_DISMISSED_KEY,
  [OnboardingPopupVariant.BOLT_STAR_PAGE]: BOLT_STAR_PAGE_ONBOARDING_DIALOG_DISMISSED_KEY,
};

const ALL_DISMISSED_KEYS = Object.values(DISMISSED_KEYS);

/** Dismissing the dialog on the Bolt Star page retires the default one as well. */
const KEYS_SET_ON_DISMISS: Record<OnboardingPopupVariant, string[]> = {
  [OnboardingPopupVariant.DEFAULT]: [BOLT_STAR_ONBOARDING_DIALOG_DISMISSED_KEY],
  [OnboardingPopupVariant.BOLT_STAR_PAGE]: ALL_DISMISSED_KEYS,
};

const markDismissed = (keys: string[]) => keys.forEach((key) => setStorageItem(key, 'true'));

export function isOnboardingDialogDismissed(variant: OnboardingPopupVariant) {
  return getStorageItem(DISMISSED_KEYS[variant]) === 'true';
}

export function dismissOnboardingDialog(variant: OnboardingPopupVariant) {
  markDismissed(KEYS_SET_ON_DISMISS[variant]);
}

export function dismissAllOnboardingDialogs() {
  markDismissed(ALL_DISMISSED_KEYS);
}
